import { render, staticRenderFns } from "./AppTagsCombobox.vue?vue&type=template&id=2b40c9ec&lang=pug&"
import script from "./AppTagsCombobox.vue?vue&type=script&lang=js&"
export * from "./AppTagsCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports